import { OrganizationView } from "@daveyplate/better-auth-ui";
import { createFileRoute, useLocation } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/$")({
	component: OrganizationViewPage,
	ssr: false,
});

function OrganizationViewPage() {
	const pathname = useLocation({ select: (location) => location.pathname });

	return (
		<div className="container mx-auto px-4 py-8">
			<OrganizationView pathname={pathname} />
		</div>
	);
}
